/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingResource {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingResource.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingResource>): AwsSecurityHubFindingResource {
        let obj = Object.assign(new AwsSecurityHubFindingResource(), model);
        AwsSecurityHubFindingResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingResource>): AwsSecurityHubFindingResource {
        if (!model) return null;
        return AwsSecurityHubFindingResource.newInstance(<AwsSecurityHubFindingResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingResource) {
        if (!obj) return;

        models.AwsSecurityHubFindingResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingResource): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Resource Type
     */
    type: string;

    /**
     * Resource Id
     */
    id: string;

    /**
     * Resource Region
     */
    region: string;

}
